import angular from "angular";

angular
	.module('app')
	.component('trChangeMileageModal', {
		template: require('./tr-change-mileage-modal.html'),
        controller: ['$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
    
function controller($http) {
 
	let $ctrl = this;
	
	$ctrl.$onInit = function () {
	    $ctrl.item = $ctrl.resolve.item;
	    $ctrl.mileage = $ctrl.item.mileage;
    };

	$ctrl.change = () => {
	    if (!$ctrl.mileage) {
	        alert('Введите новый пробег')
	        return;
        } else if ($ctrl.mileage < $ctrl.item.mileage) {
	        let userAnswer = confirm('Вы точно хотите уменьшить пробег ?')
            if (!userAnswer) {
                return;
            }
        }

        let url = '/tr/applications/' + $ctrl.resolve.applicationId + '/change-mileage/';
        let params = {
            mode: $ctrl.item.name ? 'other' : 'detail',
            item_id: $ctrl.item.id,
            mileage: $ctrl.mileage,
        }

        $http.post(url, params).then((res) => {
            $ctrl.close({
                $value: {
                    mileage: $ctrl.mileage,
                },
            }, (err) => {
                alert('Не известная ошибка, обратитесь к администраций сайта');
            });
        });
    }
}